import UserSettingConnections from './user-settings-connections';

export default UserSettingConnections;
